import React from 'react'
import { View, Text, H1, Image } from 'dripsy'
import Button from '@beatgig/components/button'
import Gradient from '@beatgig/design/components/gradient'
import useWebHeaderHeight from '@beatgig/components/web-header/use-web-header-height'
import { Platform, StyleSheet } from 'react-native'
import useOpenAuthPopup from '@beatgig/auth-hooks/use-open-auth-popup'
import useMyAccount from '@beatgig/auth-hooks/use-my-account'
import Spacer from '@beatgig/design/components/spacer'
import FloatingHeads from '@beatgig/components/floating-heads'
import AnimatedGradient from '@beatgig/components/animated-gradient'
import { Artist } from '@beatgig/api-services'
import SmartSignUpButton from '@beatgig/auth-components/smart-sign-up-button'
import NextImage from 'next/image'
import WebHeaderSpacer from '@beatgig/components/web-header/spacer'

type Props = {
  title: string
  subtitle: string
  buttons?: React.ComponentProps<typeof Button>[]
  artists?: Artist
} & React.ComponentProps<typeof View>

const color = 'text'

export default React.memo(function StripeHero(props: Props) {
  const { sx = {}, artists, title, subtitle } = props

  const minHeight = [300, 800]

  const renderStripeImage = () => {
    return (
      <View
        sx={{
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          overflow: 'visible',
        }}
      >
        <Image
          source={require('./trans.png')}
          webContainerSx={{ height: '100%' }}
          sx={{
            // height: ['60%', '75%'],
            height: [450, '67%'],
            width: '100%',
            overflow: 'visible',
          }}
          // resizeMode="cover"
        />
      </View>
    )
  }

  const renderAnimatedStripe = () => {
    return (
      <View
        webContainerSx={{
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
        }}
        sx={{
          height: ['100%', '90%'],
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        {/* <View
          sx={{
            height: '220%',
            transform: [
              {
                skewY: '-12deg',
              },
            ],
            // top: '-90%',
            top: '-125%',
            position: 'absolute',
            left: 0,
            right: 0,
          }}
        > */}
        <AnimatedGradient />
        {/* <Gradient
          sx={{
            ...StyleSheet.absoluteFillObject,
            top: 'auto',
            // bottom: -50,
            height: '20%',
          }}
          colors={['transparent', 'transparent', 'muted']}
        ></Gradient> */}
        {/* </View> */}
      </View>
    )
  }

  const renderStripe = () => {
    return (
      <View
        sx={{ height: '100%', position: 'absolute', top: 0, left: 0, right: 0 }}
      >
        <View
          sx={{
            height: '210%',
            transform: [
              {
                skewY: '-12deg',
              },
            ],
            // top: '-90%',
            top: '-125%',
            position: 'absolute',
            left: 0,
            right: 0,
          }}
        >
          <Gradient
            sx={StyleSheet.absoluteFillObject}
            colors={['cyan', 'blue', 'accent']}
          ></Gradient>
          {/* <View
            sx={{
              backgroundImage: (theme) =>
                `linear-gradient(180deg, ${theme.colors?.cyan}, ${theme.colors?.accent})`,
              ...StyleSheet.absoluteFillObject,
            }}
          /> */}
          {/* <img style={{}} /> */}
          {/* <GradientOverlay /> */}
        </View>
      </View>
    )
  }

  const renderMockup = () => {
    return (
      // <FloatingHeads
      //   images={[
      //     'https://res.cloudinary.com/dn29xlaeh/image/upload/q_75,w_640/v1/beatgig-updated/lzxdfmpblxnot3b0e9hw',
      //     'https://res.cloudinary.com/dn29xlaeh/image/upload/q_75,w_640/v1/beatgig-updated/lzxdfmpblxnot3b0e9hw',
      //   ]}
      //   sx={{ flex: 1 }}
      //   renderRelativeToChildrenZAxis="above"
      // >
      <View
        webContainerSx={{ flex: 1 }}
        sx={{ flex: 1, mt: [0, 5, 5], overflow: 'visible' }}
      >
        <Image
          source={require('./mockup3.png')}
          sx={{
            height: 800,
            alignSelf: 'flex-end',
            position: 'absolute',
            left: 0,
            bottom: 0,
            right: 0,
            top: 0,
          }}
          resizeMode="contain"
        />
        {/* <NextImage
          src="/mockup3.png"
          layout="fill"
          priority
          loading="eager"
          style={{
            height: 800,
            position: 'absolute',
            left: 0,
            bottom: 0,
            right: 0,
            top: 0,
          }}
        /> */}
      </View>
      // </FloatingHeads>
    )
  }

  const { height, top } = useWebHeaderHeight()

  const signUp = useOpenAuthPopup()
  const { data } = useMyAccount()

  return (
    <View sx={{ minHeight, width: '100%', ...sx }}>
      {/* {renderStripeImage()} */}
      <WebHeaderSpacer sx={{ bg: 'transparent' }} />
      {renderStripe()}
      {/* {renderAnimatedStripe()} */}
      {/* <View sx={{ pt: Platform.select({ web: height, default: undefined }) }} /> */}

      <View
        webContainerSx={{ flex: 1 }}
        sx={{
          pr: 2,
          // pl: [3, 0],
          // ml: [3, 0],
          flex: 1,
          maxWidth: 1255,
          width: '100%',
          alignSelf: 'center',
        }}
      >
        <View
          webContainerSx={{ flex: 1 }}
          sx={{
            flexDirection: ['column', null, 'row'],
            flex: 1,
            // justifyContent: 'center',
            mt: top,
          }}
        >
          <View
            sx={{
              flex: [null, null, 2, 2],
              // justifyContent: [null, null, 'center'],
              // justifyContent: 'center',
            }}
            webContainerSx={{
              flex: [null, null, 2, 2],
              // justifyContent: [null, null, 'center'],
            }}
          >
            <View sx={{ py: [0, 3, 4, 3], mt: 5, px: 3 }}>
              <Text
                sx={{
                  // textAlign: ['center', null, 'left'],
                  fontSize: [9, 12, 13, 13],
                  // mt: [5],
                  // mt: 70,
                  // pt: [3, null, 0],
                  lineHeight: (theme) =>
                    [9, 12, 13].map(
                      (size) => size && (theme.fontSizes?.[size] ?? size)
                    ),
                  width: '100%',
                  color,
                  fontWeight: 'bold',
                  letterSpacing: 0,
                }}
              >
                {title}
              </Text>
              <Spacer height={[3, 4]} />
              <Text
                sx={{
                  // textAlign: ['center', null, 'left'],
                  fontSize: [4],
                  lineHeight: [5],
                  width: 600,
                  color,
                  fontWeight: '600',
                  maxWidth: '100%',
                }}
              >
                {subtitle}
              </Text>
              <View
                sx={{
                  flexDirection: 'row',
                  mt: 3,
                  // justifyContent: ['center', null, 'flex-start'],
                }}
              >
                {/* <Button
                  onPress={() => !data && signUp()}
                  sx={{
                    mr: 2,
                    bg: 'background',
                    color: 'primary',
                    borderColor: 'background',
                  }}
                >
                  Start Booking
                </Button> */}
                <SmartSignUpButton sx={{ mr: 2 }} />
                {/* <Button variant="secondary">Contact Support</Button> */}
              </View>
            </View>
          </View>
          <View
            sx={{
              flex: [null, 1, 1.25, 1.5, 2],
              pb: 4,
              height: [400, 'auto'],
              display: ['none', null, 'flex'],
            }}
            webContainerSx={{ flex: [null, 1, 1.25, 1.5, 2] }}
          >
            {renderMockup()}
          </View>
        </View>
      </View>
      <Spacer height={[4, null, 0]} />
      {/* <FloatingHeads
        images={[
          'https://res.cloudinary.com/dn29xlaeh/image/upload/q_75,w_640/v1/beatgig-updated/lzxdfmpblxnot3b0e9hw',
          'https://res.cloudinary.com/dn29xlaeh/image/upload/q_75,w_640/v1/beatgig-updated/lzxdfmpblxnot3b0e9hw',
        ]}
      >
        <View sx={{ height: 150 }} />
      </FloatingHeads> */}
    </View>
  )
})
